import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ModalFilterListData } from '@shared/components/usf-filtering-modal/model/modal-filter';
import { UsfFilteringOptionComponent } from '../usf-filtering-option/usf-filtering-option-component';

@Component({
  selector: 'app-usf-filtering-list-options',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './usf-filtering-list-options.component.html',
  styleUrls: ['./usf-filtering-list-options.component.scss'],
})
export class UsfFilterListOptionsComponent
  extends UsfFilteringOptionComponent<ModalFilterListData, string[]>
  implements OnInit
{
  isAllSelected = false;
  newlySelectedOptions = [];
  selectAllForQuantitiesLargerThan = 5;

  ngOnInit(): void {
    this.newlySelectedOptions = [...this.data.newSelectedData];
    if (this.newlySelectedOptions.length === this.data.data?.size) {
      this.isAllSelected = true;
    }
  }

  get hasManyOptions() {
    return this.data.data?.size > this.selectAllForQuantitiesLargerThan;
  }

  optionSelectionChanged(event: any, key: string) {
    if (this.data.canSelectMultiple ?? true) {
      if (event.detail.checked) {
        this.newlySelectedOptions.push(key);
        if (this.newlySelectedOptions.length === this.data.data?.size) {
          this.isAllSelected = true;
        }
      } else {
        this.newlySelectedOptions.splice(
          this.newlySelectedOptions.indexOf(key),
          1,
        );
        this.isAllSelected = false;
      }
    } else {
      if (event.detail.checked) {
        this.newlySelectedOptions = [...[key]];
      } else {
        this.newlySelectedOptions = [];
      }
    }
    this.data.newSelectedData = this.newlySelectedOptions;
    this.optionSelected.emit(this.newlySelectedOptions);
  }

  selectAllChanged(event: any) {
    if (event.detail.checked) {
      this.newlySelectedOptions = Array.from(this.data.data?.keys());
      this.isAllSelected = true;
    } else {
      this.newlySelectedOptions = [];
      this.isAllSelected = false;
    }
    this.data.newSelectedData = this.newlySelectedOptions;
    this.optionSelected.emit(this.newlySelectedOptions);
  }

  mapOrder(a, b) {
    return 1;
  }
}
